<template>
    <h2>
        {{title}}
    </h2>
</template>

<script>
    export default {
        name: "TitleBlock",
        props:{
            title: String
        }
    }
</script>
